@if (formFieldSignal(); as formField) {
    <div class="flex flex-col gap-2">
        @if(!isInGrid) {
            <label class="flex gap-1 text-sm font-semibold" [for]="formField.Id">
                <div class="flex items-center" [innerHTML]="formField.Caption"></div>
                @if(formField?.aiGeneration?.generated) {
                    @if (formField?.Value) {
                        @if (formField?.aiGeneration?.confirmed){
                            <i class="ml-2 text-sm text-green-500 fa-solid fa-microchip-ai"></i>
                        }@else if (formField?.aiGeneration?.confirmed !== undefined) {
                            <i (click)="setAiButtonAcceptance(formField)" class="ml-2 text-sm text-blue-500 fa-solid fa-microchip-ai"></i>
                        }
                    }  @else if (formField?.aiGeneration?.generated) {
                        <bizz-tooltip
                                class="ml-2 relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-orange-400"
                                text="{{'AiCouldNotProcess' | translate }}"></bizz-tooltip>
                    }
                }
                @if (formField.IsRequired) {
                    <span class="relative -top-1 h-5 text-xl leading-tight text-red-400">*</span>
                }
                @if (formField && formField.Hint) {
                    <bizz-popup class="ml-1" [title]="formField.Caption" [body]="formField.Hint"></bizz-popup>
                }
                @if (errorState?.AiValidationError === undefined && errorState?.Message; as errorMessage) {
                    <bizz-tooltip
                            class="relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-red-400"
                            [text]="errorMessage"></bizz-tooltip>
                }
                @else if(formControl.errors?.['maxError'] != null || formControl.errors?.['minError'] != null){
                    <bizz-tooltip class="relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-red-400" 
                    [text]="getTranslatedValidationError()"></bizz-tooltip>
                }
            </label>
            @if(formControl.errors?.['NaN']){
                <div class="absolute right-4 top-0 z-[2] flex h-full items-center justify-center">
                    <bizz-tooltip class="cursor-pointer text-red-400" [text]="'Only (negative) numbers, your thousand separator \'.\' and your comma separator \',\' are accepted input values.'"></bizz-tooltip>
                </div>
            }
        }
    @if(formField.ProtectedFieldType == ProtectedFieldType.Size){
        <input [tabIndex]="readOnlyOverride || formField.IsReadOnly ? -1  : 0" #input class="h-10" [ngClass]="{'hidden' : formField.IsHidden}" readonly
               id="{{formField.Id}}" type="text"  [value]="formControl.value | bytes">
    }@else{
        <kendo-numerictextbox #inputKendo [class.error]="errorState?.AiValidationError === undefined && (errorState != null || formControl.errors != null)"
                              [class.errorYellow]="!formField.aiGeneration?.confirmed && formField.aiGeneration?.generated && errorState != null && errorState.AiValidationError" class="h-10"
                              [ngClass]="{'hidden' : formField.IsHidden,
                                'hide-input-text': hasDisplayStyle && !inputHasFocus, 'report-control': reportControl}"
                                (focus)="onFocus()"
                                (blur)="onBlur()"
                              [placeholder]="formField.Placeholder"
                              [min]="formField.MinValue" 
                              [max]="formField.MaxValue" 
                              [readonly]="readOnlyOverride || formField.IsReadOnly || reportControl"
                              [tabIndex]="readOnlyOverride || formField.IsReadOnly ? -1  : 0"
                              [format]="format(formField)" [formControl]="formControl" [spinners]="false"
                              [changeValueOnScroll]="false">
        </kendo-numerictextbox>
        @if(!inputHasFocus && hasDisplayStyle && (formControl.value != null && formControl.value !== '')) {
            <span class="color-preview"
            [ngClass]="{'hidden' : formField.IsHidden, 'opacity-70': formField.IsReadOnly}"
            [ngStyle]="{ 'background-color': backgroundColor, 'color': foregroundColor }">
                {{formControl.value | decimal: formField.MaxDecimals }}
            </span>
        }
    }
    </div>
}
